import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as moment from 'moment';

export class ValidatorUtils {

  constructor() {
  }

  listaSiNo: any = [
    { label: 'No', value: 'N' },
    { label: 'Si', value: 'S' }
  ]

  es: any = {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Borrar',
    dateFormat: 'dd.mm.yy',
  };

  formatoNumero(event: any) {
    let value = event;
    if (value.indexOf(',') > 0) {
      value = value.split(',').join('.');
    }
    value = Number(value).toLocaleString('de-DE');
    return value;
  }

  filtrarOpcion(lista: any, id: any) {
    let valor = null;
    if (lista !== undefined && lista.length > 0) {
      if (id !== undefined && id !== null) {
        for (let index = 0; index < lista.length; index++) {
          if (lista[index].id !== undefined && 
              lista[index].id !== null &&
              lista[index].id.toString() === id.toString()) {
            valor = lista[index];
            break;
          }
        }
      }
    }
    return valor;
  }

  filtrarOpcionValue(lista: any, id: any) {
    let valor = {};
    if (lista !== undefined && lista.length > 0) {
      if (id !== undefined && id !== null) {
        for (let index = 0; index < lista.length; index++) {
          if (lista[index].value !== undefined && 
              lista[index].value !== null &&
              lista[index].value.toString() === id.toString()) {
            valor = lista[index];
            break;
          }
        }
      }
    }
    return valor;
  }

  cleanStringify(object) {
    if (object && typeof object === 'object') {
      object = copyWithoutCircularReferences([object], object);
    }
    return JSON.stringify(object);

    function copyWithoutCircularReferences(references, object) {
      var cleanObject = {};
      Object.keys(object).forEach(function (key) {
        var value = object[key];
        if (value && typeof value === 'object') {
          if (references.indexOf(value) < 0) {
            references.push(value);
            cleanObject[key] = copyWithoutCircularReferences(references, value);
            references.pop();
          } else {
            cleanObject[key] = '###_Circular_###';
          }
        } else if (typeof value !== 'function') {
          cleanObject[key] = value;
        }
      });
      return cleanObject;
    }
  }

  /**
    * Metodo que permite validar si el campo es requido.
  */
  public static required(msg?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const res = Validators.required(control);
      if (res) {
        res.message = msg;
        return res;
      }
      return null;
    };
  }

  /**
  * Metodo que permite validar el minimo de caracteres digitados.
  */
  public static minLength(minLength: number, msg?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const ref = Validators.minLength(minLength);
      const r = ref(control);
      if (r) {
        r.message = msg;
        return r;
      }
      return null;
    };
  }

  /**
   * Metodo que permite validar el máximo de caracteres digitados.
   */
  public static maxLength(maxLength: number, msg?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const ref = Validators.maxLength(maxLength);
      const r = ref(control);
      if (r) {
        r.message = msg;
        return r;
      }
      return null;
    };
  }

  /**
   * Metodo que permite validar estructura del correo eléctronico
   */
  public static email(msg?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      if (control.value === undefined || control.value === null || control.value === '' || control.value && this.validateEmail(control.value)) {
        return null;
      } else {
        return {
          email: false,
          message: msg
        };
      }
    };
  }

  /**
   * Metodo que permite validar estructura del correo eléctronico
   */
  public static validateEmail(email: string) {
    let re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
    return re.test(email);
  }

  /**
   * Metodo que permite solo texto en los input
   */
  keyPressValTexto(e) {
    if (e.code !== 'Tab') {
      const tecla = (document.all) ? e.keyCode : e.which; // 2
      if (tecla === 8) return true; // 3
      let patron = /[a-zA-ZñÑá-úÁ-Ú\s]/; // 4
      const te = String.fromCharCode(tecla); // 5
      return patron.test(te); // 6
    }
  }

  /**
   * Metodo que permite solo números en los input
   */
  soloNumeros(e) {
    if (e.code !== 'Tab') {
      const tecla = (document.all) ? e.keyCode : e.which; // 2
      if (tecla === 8) return true; // 3
      const patron = /\d/; // 4
      const te = String.fromCharCode(tecla); // 5
      return patron.test(te); // 6
    }
  }

  soloNumerosDecimales(e) {
    if (e.code !== 'Tab') {
      const tecla = (document.all) ? e.keyCode : e.which; // 2
      if (tecla === 8) return true; // 3
      let patron = /[\d.]/; // 4
      const te = String.fromCharCode(tecla); // 5
      return patron.test(te); // 6
    }
  }

  /**
   * Valida el n úmero de documento a digitar.
   * Si es cedula solo permite números de lo contrario permite 
   * letras.
   */
  keyPressValDocumento(event: any, tipoIdentificacion: string) {
    const tecla = (document.all) ? event.keyCode : event.which;
    const patron = /[A-Za-z0-9]/;
    if (event.code !== 'Tab' && event.code !== 'Backspace') {
      if (tipoIdentificacion !== '62' && tipoIdentificacion !== '2534') {
        return this.soloNumeros(event);
      } else {
        const tecla_final = String.fromCharCode(tecla);
        return patron.test(tecla_final);
      }
    }
  }

  /**
   * Filtra la fecha hasta la actual.
   */
  fiterCurrent = (date: Date): boolean => {
    return date < (new Date());
  }

  public static pattern(pattern: string, msg?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const ref = Validators.pattern(pattern);
      const r = ref(control);
      if (r) {
        r.message = msg;
        return r;
      }
      return null;
    };
  }

  /**
   * Metodo que permite indicar que el campo es obligatorio.

   */
  public getValidationRequired(): { [key: string]: any } {
    return [null, Validators.compose([
      ValidatorUtils.required('Debe diligenciar este campo.')
    ]
    )];
  }

  public getValidationCorreoElectronico(): { [key: string]: any } {
    return [null, Validators.compose([
      ValidatorUtils.maxLength(100, 'Correo electrónico debe tener máximo 100 caracteres'),
      ValidatorUtils.email('Estructura del correo invalida')]
    )];
  }

  public getValidationCorreoElectronicoRequired(): { [key: string]: any } {
    return [null, Validators.compose([
      ValidatorUtils.maxLength(100, 'Correo electrónico debe tener máximo 100 caracteres'),
      ValidatorUtils.email('Estructura del correo invalida'),
      ValidatorUtils.required('Debe diligenciar este campo.')]
    )];
  }

  /**
   * Formatear fecha yyyy-mm-dd
   */
  formatDate(date) {
    const mes = date.getMonth() + 1; // Ya que los meses los cuenta desde el 0
    const dia = date.getDate();
    const hora = date.getHours();
    const minutos = date.getMinutes();
    const segundos = date.getSeconds();
    return `${(dia < 10 ? '0' : '').concat(dia)}/${(mes < 10 ? '0' : '').concat(mes)}/${date.getFullYear()} ${(hora < 10 ? '0' : '').concat(hora)}:${(minutos < 10 ? '0' : '').concat(minutos)}:${(segundos < 10 ? '0' : '').concat(segundos)}`;
  }

  /**
   * Formatear fecha yyyy-mm-dd
   */
  formatDateTwo(date) {
    const mes = date.getMonth() + 1; // Ya que los meses los cuenta desde el 0
    const dia = date.getDate();
    return `${(dia < 10 ? '0' : '').concat(dia)}/${(mes < 10 ? '0' : '').concat(mes)}/${date.getFullYear()}`;
  }

  /**
   * Limpia los campos de los formularios.
   */
  clearFields(controls: any) {
    let control: AbstractControl = null;
    Object.keys(controls).forEach((name) => {
      control = controls[name];
      control.setErrors(null);
    });
  }

  getValidData(e, date1: Date, date2: Date, msg) {
    if (date1 !== null && date2 !== null) {
      if (date1 > date2) {
        e.setErrors({ 'incorrect': true, message: msg });
      }
    }
  }

  public getFechaFin(fechaValidar: Date, edad: number): Date {
    let dateModifi = new Date();
    dateModifi.setDate(new Date(fechaValidar).getDate());
    dateModifi.setMonth(new Date(fechaValidar).getMonth());
    dateModifi.setFullYear(fechaValidar.getFullYear() + edad);
    return dateModifi;
  }

  calcDate(date1, date2): boolean {
    let mayor = false;
    const years = moment().diff(date1, 'years');

    if (years > 18) {
      mayor = true;
    } else if (years === 18) {
      const mes = date2.getMonth() - date1.getMonth();
      if (mes < 0) {
        mayor = true;
      } else if (mes === 0) {
        const dia = date2.getDate() - date1.getDate();
        if (dia <= 0) {
          mayor = true;
        }
      }
    }

    return mayor;
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1.codigo === o2.codigo;
  }

  displayFndGeneral(value: any): string {
    let x;
    if (value && typeof value === 'object') {
      x = value.descripcion;
    } else {
      x = value;
    }
    return x;
  }

  formatoFecha(texto) {
    if (!this.validarFormatoFecha(texto)) {
      return texto.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
    }
    return texto;
  }

  validarFormatoFecha(campo) {
    var RegExPattern = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;
    if ((campo.match(RegExPattern)) && (campo != '')) {
      return true;
    } else {
      return false;
    }
  }

  getValor(objeto){
    if(objeto !== undefined && objeto !== null && objeto){ 
      return objeto;
    } else {
      return null;
    }
  }

  

}
